module.exports = __webpack_public_path__ + "static/media/dashboard-welcome-teacher.6fbfc224.svg";